export enum PublishedBoardsModule {
  CORE = 'CORE',
  EMISSIONS = 'EMISSIONS',
  TRANSITIONS = 'TRANSITIONS',
  CALCULATIONS = 'CALCULATIONS',
  INTERVENTIONS = 'INTERVENTIONS',
  SEARCH = 'SEARCH',
}
